import SectionHeader from './SectionHeader';
import { statusBadge, heatColor } from './statusUtil';
import { hotMelons } from '../../../mocks/gossip';

export default function HotMelons() {
  return (
    <section id="hot" className="mx-auto max-w-7xl scroll-mt-20 px-4 py-14 md:px-6 md:py-20">
      <SectionHeader
        eyebrow="实时滚屏中"
        title="今日热瓜"
        desc="前排围观现场实时更新，热度越高的瓜排得越靠前。点开详情即可蹲进对应事件现场，一手动态与评论区同步刷新。"
      />

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {hotMelons.map((m, idx) => {
          const s = statusBadge(m.status);
          return (
            <article
              key={m.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-shadow hover:shadow-md"
            >
              <div className="relative h-44 w-full overflow-hidden md:h-48">
                <img
                  src={m.image}
                  alt={`${m.title} - 呱呱吃瓜围观现场`}
                  title={`${m.title} · 前排吃瓜`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-background-950/70 px-2 py-1 text-xs text-background-50">
                  <i className="ri-fire-fill text-secondary-400"></i>
                  热度 {m.heat}
                </span>
                {idx === 0 && (
                  <span className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-secondary-500 text-sm text-background-50">
                    <i className="ri-star-smile-fill"></i>
                  </span>
                )}
              </div>

              <div className="flex flex-1 flex-col p-4 md:p-5">
                <div className="flex flex-wrap items-center gap-2">
                  <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs ${s.cls}`}>
                    <i className={s.icon}></i>
                    {m.status}
                  </span>
                  <span className="whitespace-nowrap rounded-full bg-background-100 px-2.5 py-0.5 text-xs text-foreground-500">
                    {m.tag}
                  </span>
                </div>

                <h3 className="mt-3 flex-1 text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
                  <a href="#live">{m.title}</a>
                </h3>

                <p className="mt-2 line-clamp-2 text-sm text-foreground-600">{m.brief}</p>

                <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3">
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-chat-3-line"></i>
                      {m.commentCount} 条讨论
                    </span>
                  </div>
                  <div className="flex items-center gap-1 whitespace-nowrap text-xs text-foreground-400">
                    <i className="ri-time-line"></i>
                    {m.time}
                  </div>
                </div>
              </div>
            </article>
          );
        })}
      </div>

      <div className="mt-8 text-center">
        <a
          href="#live"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-6 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100"
        >
          蹲进更多现场
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </section>
  );
}